import { init } from "@metaapp/APM-browser";
import { pandoraPlugin } from "@metaapp/APM-pandora";
import Pandora from "metaapp-pandora-sdk";

import { LogReport as logReport } from "metaapp-log-report";
const m = logReport({
  appKey: "cDEwMTE3",
  type: "web/official/p-233game-website-public",
  consoleShow: false,
  env: "prod",
  url: location.href,
});
m.log({
  desc: "页面展示",
  url: location.href,
});
Pandora.send(
  "config",
  {
    index_type: "cDEwMTE3/wl", //web填 'wl'一般情况；官网的是wl_233leyuan_official_website
    selfpackagename: "web_tool", //指定app包名；乐园：com.meta.box,小游戏：com.meta.xyx,官网：com.233leyuan.www
    send_interval: 100, //发送间隔(ms)
    debug: false, //调试模式，vue在非debug模式下会拦截所有错误信息
    project_type: "p-233game-website-public",
    //... //其他 (每次请求都会附带)
  },
  {
    appkey: "cDEwMTE3", // 可选参数appkey appkey的值将会添加到埋点请求头部 字段名称为X-MCS-AppKey
    zone: "zh", // 使用国内域名或者海外域名 可选择 zh, en 当zone的值设置为en时将会使用海外域名，同时appkey将会作为接口的一级路径拼接在域名后方
    baseUrl: "https://push.233leyuan.com",
  }
);
Pandora.send("start");
//然后给plugin传入 pandora 实例
init({
  plugins: [pandoraPlugin(Pandora)],
  dsn: location.href,
});



// WEBPACK FOOTER //
// ./src/assets/js/main.js